import { render } from "./TheNhomThanhTichTheThaoVH.vue?vue&type=template&id=ff9a6c2a"
import script from "./TheNhomThanhTichTheThaoVH.vue?vue&type=script&lang=js"
export * from "./TheNhomThanhTichTheThaoVH.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__